<div class="w-full">
  @if (userIsSpecial()) {
    <app-my-forest-main-info-special class="block w-full" />
  } @else {
    <app-my-forest-main-info class="block w-full" />
  }
</div>
